import { useSuspenseQuery } from "@tanstack/react-query";

import { useEnableGcpFakeSystemEngine } from "featureFlags/hooks/useEnableGcpFakeSystemEngine";
import { ReactQueryKeysAccount } from "services/queryKeys";

import { getSchemaNames } from "./getSchemaNames";

export type Schema = {
  schemaName: string;
};

export const useSchemaNames = ({
  database,
}: {
  database: string;
}): Schema[] => {
  const endpoint = useEnableGcpFakeSystemEngine();
  const { data } = useSuspenseQuery<Schema[], Error>({
    queryKey: [ReactQueryKeysAccount.schemaNames, database],
    queryFn: async () => {
      const schemaNames = await getSchemaNames(database, endpoint);
      return schemaNames;
    },
  });
  return data || [];
};
